const eventBus = new window.Vue();
export default eventBus;
